import { render, staticRenderFns } from "./CetakInvoiceReturnComponent.vue?vue&type=template&id=21cd5c8e"
import script from "./CetakInvoiceReturnComponent.vue?vue&type=script&lang=js"
export * from "./CetakInvoiceReturnComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports